import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import FaiButton from "MuiComponents/FaiButton";
import useJSONForm from "components/JSONForm/useJSONForm";
import { salesFormSchema } from "./FormSchema";
import BackIcon from "components/AppIcons/BackIcon";

const SalesDetails = ({ editData = false }: any) => {
	const navigate = useNavigate();

	const goBack = () => navigate(-1);

	// Form
	const { Form } = useJSONForm({
		formSchema: salesFormSchema,
		customComponents: {
			actionBtn: (
				<div className="w-full flex justify-start mt-5 gap-2">
					<FaiButton type="submit" color="primary">
						Add Sale
					</FaiButton>
					<FaiButton variant="outlined">Cancel</FaiButton>
				</div>
			),
		},
		// defaultValue: defaultValue ? defaultValue : initialValues,
	});

	const onSubmit = (data: any) => {
		console.log("submit data", data);
	};

	return (
		<Box className="bg-white rounded-2xl p-6 my-3 md:my-6">
			<Button
				startIcon={<BackIcon />}
				sx={{ mb: 2 }}
				onClick={goBack}
				className="text-theme"
			>
				Back to Sales
			</Button>
			{!!editData && (
				<Box className="my-3 px-2">
					<Typography variant="h6" className="!text-xl !font-semibold">
						{editData.title}
					</Typography>
				</Box>
			)}
			<Form customFormActions onSubmit={onSubmit} />
		</Box>
	);
};

export default SalesDetails;
